import React, { useContext, useEffect, useState } from "react";

import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { UserContext } from "../../../context";
import firebase from "../../../firebase";
import ProjectComponentFrame from "./ProjectComponentFrame";

export default function ProjectTitleComponent(props) {
    const { currentUserData } = useContext(UserContext);
    const [projectKey, setProjectKey] = useState("");
    const [text, setText] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (currentUserData && props.component) {
            setProjectKey(props.projectKey);
            setIsEditing(props.isEditing);
            setText(props.component.text);
        }
    }, [currentUserData, props.component, props.isEditing, props.projectKey]);

    function handleTextFieldChange(event) {
        const newValue = event.target.value;

        if (event.target.id === "text") {
            setText(newValue);
            props.component.text = newValue;

            if (projectKey !== "") {
                firebase
                    .database()
                    .ref("projects")
                    .child(projectKey)
                    .child("components")
                    .child(props.component.key)
                    .child("text")
                    .set(newValue);
            }
        }
    }

    return (
        <ProjectComponentFrame
            component={props.component}
            isEditing={isEditing}
            label="Title"
            onDelete={() => props.delete(props.component)}
            onMoveUp={() => props.moveUp(props.component)}
            onMoveDown={() => props.moveDown(props.component)}
        >
            {isEditing ? (
                <TextField
                    fullWidth
                    value={text}
                    id="text"
                    onChange={handleTextFieldChange}
                    label="Title"
                    placeholder="Add a section title"
                />
            ) : (
                <Typography
                    variant="h5"
                    component="h2"
                    sx={{ color: "primary.main", overflowWrap: "anywhere" }}
                >
                    {text || "Untitled section"}
                </Typography>
            )}
        </ProjectComponentFrame>
    );
}
